import React from 'react';

const imageContext = require.context('./images', false, /\.(jpg|jpeg|png)$/);

const MyImageComponent = ({ itemName }) => {
    const getImagePath = (name) => {
        let formattedName = name.replace(/`/g, '');
        if (formattedName.endsWith('frame')) {
            formattedName = formattedName.slice(0, -5);
        }
        formattedName = formattedName.replace(/\s+/g, '');

        try {
            return imageContext(`./frame-${formattedName}.jpg`);
        } catch (err) {
            console.error('Image not found:', err);
            return '';
        }
    };

    const imagePath = getImagePath(itemName);

    return (
        <img src={imagePath} alt={itemName} />
    );
};

export default MyImageComponent;
